export { default } from './TextWithClampedOverflow';
